module.exports = __webpack_public_path__ + "img/motor_no18.120d0858.jpg";